import { KeyRound } from "lucide-react";
import { convertArrayToOptionType, EMAIL_REGEX, FormField, NAME_REGEX, USER_ROLES } from "src/helpers";
import * as Yup from "yup";

export type ILoginForm = {
  mobileNumber: string;
  password: string;
  captcha?: string;
};
export type IRegistrationForm = {
  // email: string,
  // firstName: string,
  // lastName: string,
  mobileNumber: string;
  password: string;
  // confirm_password: string,
  is_accept: boolean;
  role: string;

  // referralCode?: string
};

export type IForgotForm = {
  mobileNumber: string;
};

export type IResetPassword = {
  mobileNumber: string;
  password: string;
  confirm_password: string;
};

export const loginFormValidationSchema = Yup.object().shape({
  mobileNumber: Yup.string().length(10, "Must be 10 digits").required("Mobile Number is required"),
  captcha: Yup.string().required("Captcha is required"),
  password: Yup.string()
    .min(8, "Password must be at least 8 characters")
    .matches(
      /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,16}$/,
      "Password must be at least 8 characters and include 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character"
    )
    .min(8, "Minimum 8 characters")
    .max(16, "Maximum 16 characters")
    .required("Password is required"),
});

export const registrationFormValidationSchema = Yup.object().shape({
  // email: Yup.string()
  //   .email('Invalid email address')
  //   .required('Email is required'),
  // firstName: Yup.string().required('First Name is required'),
  // lastName: Yup.string().required('Last Name is required'),
  mobileNumber: Yup.string().length(10, "Must be 10 digits").required("Mobile Number is required"),
  password: Yup.string()
    .min(8, "Password must be at least 8 characters")
    .required("Password is required")
    .matches(
      /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,16}$/,
      "Password must be at least 8 characters and include 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character"
    )
    .min(8, "Minimum 8 characters")
    .max(16, "Maximum 16 characters"),
  // confirm_password: Yup.string()
  //   .min(8, 'Password must be at least 8 characters')
  //   .required('Password is required')
  //   .test('passwords-match', 'Passwords not match', function (value) {
  //     return this.parent.password === value;
  //   }),
  is_accept: Yup.boolean().test("is_accept_term", "please read and accept conditions ", function (value) {
    return this.parent.is_accept === true;
  }),
  role: Yup.string().required("Role is required"),
});

export const ResetPasswordFormValidationSchema = Yup.object().shape({
  password: Yup.string()
    .min(8, "Password must be at least 8 characters")
    .matches(
      /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,16}$/,
      "Password must be at least 8 characters and include 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character"
    )
    .min(8, "Minimum 8 characters")
    .max(16, "Maximum 16 characters")
    .required("Password is required"),
  confirm_password: Yup.string()
    .min(8, "Password must be at least 8 characters")
    .required("Confirm Password is required")
    .test("passwords-match", "Passwords not match", function (value) {
      return this.parent.password === value;
    }),
});

export const forgotFormValidationSchema = Yup.object().shape({
  mobileNumber: Yup.string().length(10, "Must be 10 digits").required("Mobile Number is required"),
});

export const login_initialValues: ILoginForm = {
  mobileNumber: "",
  password: "",
  captcha: "",
};

export const forgot_initialValues: IForgotForm = {
  mobileNumber: "",
};

export const registration_initialValues: IRegistrationForm = {
  // email: '',
  // firstName: "",
  // lastName: "",
  mobileNumber: "",
  password: "",
  // confirm_password: "",
  is_accept: false,
  role: "",
};

export const resetpassword_initialValues: IResetPassword = {
  mobileNumber: "",
  password: "",
  confirm_password: "",
};

export const LOGIN_FORM_FIELDS: FormField[] = [
  {
    label: "Contact Number",
    dataKey: "mobileNumber",
    componentType: "input",
    componentProps: {
      type: "number",
      maxLength: 10,
      required: true,
    },
  },
  {
    label: "Password",
    dataKey: "password",
    componentType: "input",
    componentProps: {
      type: "password",
      inputPrefixIcon: <KeyRound className="text-gray-500" size={16} />,
    },
  },
];

export const FORGOT_FORM_FIELDS: FormField[] = [
  {
    label: "Contact Number",
    dataKey: "mobileNumber",
    componentType: "input",
    componentProps: {
      type: "number",
      maxLength: 10,
      required: true,
    },
  },
];

export const REGISTRATION_FORM_FIELDS: FormField[] = [
  // {
  //   label: 'Email',
  //   dataKey: 'email',
  //   componentType: 'input',
  //   componentProps: {
  //     type: 'email',
  //     required: true,
  //     inputPrefixIcon: <AtSign className='text-gray-500' size={16} />,
  //   }
  // },
  // {
  //   label: 'First Name',
  //   dataKey: 'firstName',
  //   componentType: 'input',
  //   componentProps: {
  //     type: 'text',
  //     regex: NAME_REGEX,
  //     required: true,

  //   }
  // },
  // {
  //   label: 'Last Name',
  //   dataKey: 'lastName',
  //   componentType: 'input',
  //   componentProps: {
  //     type: 'text',
  //     regex: NAME_REGEX,
  //     required: true,

  //   }
  // },
  {
    label: "Contact Number",
    dataKey: "mobileNumber",
    componentType: "input",
    componentProps: {
      type: "number",
      maxLength: 10,
      required: true,
    },
  },
  {
    label: "Role",
    dataKey: "role",
    componentType: "options",
    componentProps: {
      required: true,
      options: convertArrayToOptionType(Object.values(USER_ROLES)),
    },
  },
  {
    label: "Password",
    dataKey: "password",
    componentType: "input",
    componentProps: {
      type: "password",
      required: true,
      inputPrefixIcon: <KeyRound className="text-gray-500" size={16} />,
    },
  },
  // {
  //   label: 'Confirm Password',
  //   dataKey: 'confirm_password',
  //   componentType: 'input',
  //   componentProps: {
  //     type: 'password',
  //     required: true,
  //     inputPrefixIcon: <KeyRound className='text-gray-500' size={16} />
  //   }
  // },
  // {
  //   label: 'Referral Code',
  //   dataKey: 'referralCode',
  //   componentType: 'input',
  //   componentProps: {
  //     type: 'text',
  //   }
  // },
];

export const RESET_PASSWORD_FORM_FIELDS: FormField[] = [
  {
    label: "Password",
    dataKey: "password",
    componentType: "input",
    componentProps: {
      type: "password",
      inputPrefixIcon: <KeyRound className="text-gray-500" size={16} />,
    },
  },
  {
    label: "Confirm Password",
    dataKey: "confirm_password",
    componentType: "input",
    componentProps: {
      type: "password",
      inputPrefixIcon: <KeyRound className="text-gray-500" size={16} />,
    },
  },
];
